import React from 'react';


class HighThreshold extends React.Component {
    constructor(props) {
        super(props);

        this.initialState = {
            warningHigh: this.props.defaultWarningHigh,
            criticalHigh: this.props.defaultCriticalHigh,

            error: ''
        };

        this.state = {
            ...this.initialState
        };

        this.onValueChange = this.onValueChange.bind(this);
    }

    setError(error) {
        this.setState({ error });
    }

    getValue() {
        const { warningHigh, criticalHigh } = this.state;

        return {
            warningLow: 0,
            warningHigh,
            criticalLow: 0,
            criticalHigh
        };
    }

    setValue(value) {
        this.setState(value);
        this.validate(value);
    }

    clearValue() {
        this.setState({ ...this.initialState });
    }

    isValid() {
        return this.validate(this.getValue());
    }

    onValueChange(evt, valueName) {
        const value = evt.target.value;

        this.setState({
            [valueName]: value
        }, () => {
            this.validate(this.getValue());
        });
    }

    validate(value) {
        for (let i = 0; i < this.props.validators.length; i+= 1) {
            const v = this.props.validators[i];
            const error = v(value);

            if (error) {
                this.setError(error);
                return false;
            }
        }

        this.setState({ error: '' });
        return true;
    }

    renderError() {
        if (!this.state.error) {
            return null;
        }

        return (
            <span className='form-error'>
                {this.state.error}
            </span>
        );
    }

    render() {
        const classes = ['form-field', 'high-threshold-field'];

        if (this.state.error) {
            classes.push('form-field-error');
        }

        return (
            <div className={classes.join(' ')}>
                <fieldset>
                    <legend>{this.props.label}</legend>

                    <div className='high-threshold-containers'>
                        <div className='high-threshold-container'>
                            <label htmlFor={this.props.name + '-warning'}>Warning high</label>

                            <input id={this.props.name + '-warning'}
                                   name={this.props.name + '-warning'}
                                   type='text'
                                   value={this.state.warningHigh}
                                   onChange={(evt) => { this.onValueChange(evt, 'warningHigh'); }}
                                   maxLength='255'
                                   className='form-input'/>
                        </div>

                        <div className='high-threshold-container'>
                            <label htmlFor={this.props.name + '-critical'}>Critical high</label>

                            <input id={this.props.name + '-critical'}
                                   name={this.props.name + '-critical'}
                                   type='text'
                                   value={this.state.criticalHigh}
                                   onChange={(evt) => { this.onValueChange(evt, 'criticalHigh'); }}
                                   maxLength='255'
                                   className='form-input'/>
                        </div>
                    </div>
                </fieldset>

                {this.renderError()}
            </div>
        );
    }
}

HighThreshold.defaultProps = {
    defaultWarningHigh: 0,
    defaultCriticalHigh: 0,
    validators: []
};

export default HighThreshold;
